export const supplierSubmenuItems = {
    team: { text: 'People', path: '/team/people', langKey: 'submenu-people' },
    companyInformation: { text: 'Company Information', path: '/company-information', langKey: 'submenu-company-information' },
    billing: { text: 'Billing', path: '/billing', langKey: 'submenu-billing' },
    contracts: { text: 'Contracts', path: '/contracts', langKey: 'submenu-contracts' },
    tasksReminders: { text: 'Tasks/Reminders', path: '/supplier/tasks-reminders', langKey: 'submenu-tasks-and-reminders' }
};

export const HIDDEN_MENU_ITEMS = [];
